import { useState } from "react"
import { useLocation } from "react-router-dom"

const useFirstLocation = () => {
  const location = useLocation().pathname + window.location.search

  const updatedPathname = location === "/" ? "/ride/home" : location

  const [pathname] = useState(updatedPathname)

  return pathname
}

export { useFirstLocation }
